import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Button, Modal, Form } from '_zari/core'

import * as AsientoContableService from 'services/asientosContables.service'

import * as FormGroups from './formGroups'

const ReporteEntregasModal = ({ show, handleClose }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.memo(() => {
    return {
      _idPartida: '',
      _idSocio: '',
      nombreSocio: ''
    }
  }, [])

  const onSubmit = React.useCallback(
    (data, { setSubmitting }) => {
      if (!data._idPartida) {
        __zariContext.snack('error', "Debe seleccionar una partida para continuar")
        setSubmitting(false)
        return
      }
      __zariContext.loader.open('Descargando reporte estados financieros')
      AsientoContableService.descargarReporteEntregas(data)
        .then(({ data }) => {
          const linkSource = window.URL.createObjectURL(new Blob([data]))
          const downloadLink = document.createElement('a')
          const fileName = 'reporte-entregas.xlsx'

          downloadLink.href = linkSource
          downloadLink.download = fileName
          document.body.appendChild(downloadLink)
          downloadLink.click()

          handleClose()
        })
        .catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
          setSubmitting(false)
        })
        .finally(() => {
          __zariContext.loader.close()
        })
    },
    [__zariContext, handleClose]
  )

  return (
    <Modal show={show}>
      <Modal.Header>
        <Modal.Title>Reporte Entregas a Rendir</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={onSubmit}>
        {({ errors, touched, isSubmitting, values, handleSubmit, setValues }) => (
          <Form>
            <Modal.Body>
              <FormGroups.SocioFormGroup
                fIsSubmitting={isSubmitting}
                iError={errors._idSocio}
                iTouched
                iValue={values.nombreSocio}
                setValues={setValues}
                values={values}
              />
              <FormGroups.PartidaFormGroup
                fIsSubmitting={isSubmitting}
                iError={errors._idPartida}
                iTouched={touched._idPartida}
                vSocio={values._idSocio}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose} disabled={isSubmitting}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit} disabled={isSubmitting}>
                Descargar
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default React.memo(ReporteEntregasModal)
